import React from "react";
import { Box, Typography } from "@mui/material";
import { useStyles } from "./ActivitesSectionStyle";

const YourActivity = ({ Title, src, about }) => {
  const classes = useStyles();

  return (
    <Box
      className={
        Title === "Complexe Industrie"
          ? classes.YourActivityContainerComplexe
          : classes.YourActivityContainer
      }
    >
      <Box
        style={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <img src={src} alt="" height={100} width={113} />
        <Typography className={classes.YourActivityHeading}>{Title}</Typography>
        <Typography className={classes.YourActivityPara}>{about}</Typography>
      </Box>
    </Box>
  );
};

export default YourActivity;
